import { useUIConfiguration } from "@/contexts/UIConfiguration";
import { useLogout } from "@/utils/logout";
import { useScaffold } from "@Light/scaffold/hook";
import { XClose } from "@untitledui/icons";
import clsx from "clsx";

export type CloseIconProps = {
  className?: string;
};

export const CloseIcon: React.FC<CloseIconProps> = ({ className }) => {
  const logout = useLogout("close_icon");
  const scaffold = useScaffold();
  return (
    <button
      className="flex h-10 w-10 items-center justify-center rounded-full bg-white"
      onClick={() => {
        logout();
      }}
    >
      <XClose
        className={clsx(
          "w-6 h-6 cursor-pointer",
          scaffold.page.colors.text.primary,
          className,
        )}
      />
    </button>
  );
};

export const HeaderCloseButton: React.FC = () => {
  const { hideCloseButton } = useUIConfiguration();
  if (hideCloseButton) {
    return <></>;
  }
  return <CloseIcon />;
};
